import { ConfigurationType, RuleType } from "./types";

// ── Firestore Path Helpers ───────────────────────────────────────────────────

export const getGenericRulesDocumentPath = (orgId: string): string =>
  `api_config/${orgId}/medical_necessity/agent_rules/general_rules/rules`;

export const getGenericRulesCollectionPath = (orgId: string): string =>
  `api_config/${orgId}/medical_necessity/agent_rules/general_rules`;

export const GENERIC_RULES_DOC_ID = "rules";

export const getDrugSpecificRulesDocumentPath = (
  orgId: string,
  drugId: string,
): string =>
  `api_config/${orgId}/medical_necessity/agent_rules/drug_specific/${drugId}/rules/rules`;

export const getDrugSpecificRulesCollectionPath = (
  orgId: string,
  drugId: string,
): string =>
  `api_config/${orgId}/medical_necessity/agent_rules/drug_specific/${drugId}/rules`;

export const DRUG_SPECIFIC_RULES_DOC_ID = "rules";

// ── UI Toggle Options ────────────────────────────────────────────────────────

export const CONFIGURATION_TYPE_OPTIONS: {
  label: string;
  value: ConfigurationType;
}[] = [
  { label: "Generic", value: "generic" },
  { label: "Drug Specific", value: "drug_specific" },
];

export const RULE_TYPE_OPTIONS: { label: string; value: RuleType }[] = [
  { label: "Evidence Based", value: "evidence_based" },
  { label: "Fixed Response", value: "fixed_response" },
];

export const PANEL_SUBTITLES: Record<
  RuleType,
  { mcq: string; subjective: string }
> = {
  evidence_based: {
    mcq: "Multiple choice questions based on medical evidence",
    subjective: "Open-ended questions based on medical evidence",
  },
  fixed_response: {
    mcq: "Multiple choice questions with fixed responses",
    subjective: "Open-ended questions with fixed responses",
  },
  policy_override: {
    mcq: "Policy override rules",
    subjective: "Policy override rules",
  },
};

// ── Toast IDs ────────────────────────────────────────────────────────────────

export const TOAST_IDS = {
  SAVE_SUCCESS: "medical-necessity-save-success",
  SAVE_FAILURE: "medical-necessity-save-failure",
};
